import {
  Business,
  Schedule,
  WorkOutline,
  EventAvailable,
} from '@mui/icons-material';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Button,
  Chip,
  CircularProgress,
} from '@mui/material';
import PropTypes from 'prop-types';
import { getFormattedDateTimeWOSecs } from '../../formatter/date';
import LOGIN_TYPE from '../../constants/loginType';
import UI from '../../constants/ui';

function UpcomingEventsSection({
  upcomingEvents,
  role,
  handleClickRegister,
  handleClickShowInterest,
  statusLoadingIdId,
  handleDialogOpen,
}) {
  return (
    <Grid
      container
      spacing={4}
      justifyContent={upcomingEvents.length < 3 ? 'center' : 'flex-start'}
    >
      {upcomingEvents.map((event, index) => (
        <Grid
          item
          xs={12}
          sm={upcomingEvents.length === 1 ? 12 : 6}
          md={upcomingEvents.length < 3 ? 5 : 4}
          key={index}
          display="flex"
          justifyContent="center"
        >
          <Card
            elevation={6}
            sx={{
              width: '100%',
              maxWidth: 400,
              borderRadius: 4,
              overflow: 'hidden',
              background: 'linear-gradient(135deg, #ffffff 0%, #f9f9f9 100%)',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-8px)',
                boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
              },
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box mb={2}>
                <a onClick={() => handleDialogOpen(event.details)}>
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    sx={{
                      color: '#333',
                      mb: 1,
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <EventAvailable sx={{ color: '#f5576c', mr: 1 }} />
                    {event.event}
                  </Typography>
                </a>

                {event.jobTitle && (
                  <a
                    href={`/job/${event.jobId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Chip
                      label={event.jobTitle}
                      size="small"
                      sx={{
                        bgcolor: '#e0f7fa',
                        color: '#00796b',
                        fontWeight: 500,
                        fontSize: 12,
                        cursor: 'pointer',
                      }}
                      icon={<WorkOutline sx={{ fontSize: 18 }} />}
                    />
                  </a>
                )}
              </Box>

              {event.companyName !== 'Global' && (
                <Typography
                  variant="body2"
                  sx={{
                    color: '#555',
                    display: 'flex',
                    alignItems: 'center',
                    mb: 1,
                  }}
                >
                  <Business sx={{ fontSize: 18, mr: 1, color: '#2196f3' }} />
                  <strong>Company:</strong>&nbsp;{event.companyName}
                </Typography>
              )}

              <Typography
                variant="body2"
                sx={{
                  color: '#555',
                  display: 'flex',
                  alignItems: 'center',
                  mb: 1,
                  mt: event.companyName === 'Global' ? 5 : 0,
                }}
              >
                <Schedule sx={{ fontSize: 18, mr: 1, color: '#ff9800' }} />
                <strong>Start:</strong>&nbsp;
                {getFormattedDateTimeWOSecs(event.start)}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: '#555',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Schedule sx={{ fontSize: 18, mr: 1, color: '#9c27b0' }} />
                <strong>End:</strong>&nbsp;
                {getFormattedDateTimeWOSecs(event.end)}
              </Typography>

              <Box
                display="flex"
                flexDirection="row"
                gap={2}
                pt={2}
                mt={event.companyName === 'Global' ? 4 : 0}
              >
                {role === LOGIN_TYPE.CANDIDATE ? (
                  event.state === 1 ? (
                    <Button
                      onClick={() => handleClickRegister(event)}
                      variant="contained"
                      fullWidth
                      sx={{
                        bgcolor: event.registered ? '#50C878' : '#1976d2',
                        '&:hover': {
                          bgcolor: event.registered ? '#45b06c' : '#1565c0',
                        },
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: 15,
                        py: 1.2,
                      }}
                    >
                      {event.registered ? (
                        statusLoadingIdId === event.id ? (
                          <CircularProgress size={22} sx={{ color: 'white' }} />
                        ) : (
                          UI.CHECK_PROGRESS
                        )
                      ) : (
                        UI.REGISTER_
                      )}
                    </Button>
                  ) : (
                    <Box
                      sx={{
                        py: 1.2,
                        px: 3,
                        bgcolor: '#c8d1de',
                        borderRadius: 2,
                        fontWeight: 600,
                        textAlign: 'center',
                      }}
                    >
                      {UI.INACTIVE}
                    </Box>
                  )
                ) : role === LOGIN_TYPE.EMPLOYER ? (
                  event.state === 1 ? (
                    <Button
                      onClick={() => handleClickShowInterest(event)}
                      variant="contained"
                      fullWidth
                      sx={{
                        bgcolor: '#1976d2',
                        '&:hover': { bgcolor: '#1565c0' },
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: 15,
                        py: 1.2,
                      }}
                    >
                      {UI.SHOW_INTEREST}
                    </Button>
                  ) : (
                    <Box
                      sx={{
                        py: 1.2,
                        px: 3,
                        bgcolor: '#c8d1de',
                        borderRadius: 2,
                        fontWeight: 600,
                        textAlign: 'center',
                      }}
                    >
                      {UI.INACTIVE}
                    </Box>
                  )
                ) : (
                  <Box width="100%">
                    {event.state === 1 ? (
                      <Button
                        onClick={() => handleClickRegister(event)}
                        variant="contained"
                        fullWidth
                        sx={{
                          bgcolor: '#1976d2',
                          '&:hover': {
                            bgcolor: '#1565c0',
                          },
                          borderRadius: 2,
                          textTransform: 'none',
                          fontWeight: 600,
                          fontSize: 15,
                          py: 1.2,
                        }}
                      >
                        {UI.REGISTER_}
                      </Button>
                    ) : (
                      <Box
                        sx={{
                          py: 1.2,
                          px: 3,
                          bgcolor: '#c8d1de',
                          borderRadius: 2,
                          fontWeight: 600,
                          textAlign: 'center',
                        }}
                      >
                        {UI.INACTIVE}
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default UpcomingEventsSection;

UpcomingEventsSection.propTypes = {
  upcomingEvents: PropTypes.array.isRequired,
  role: PropTypes.string.isRequired,
  handleClickRegister: PropTypes.func.isRequired,
  handleClickShowInterest: PropTypes.func.isRequired,
  statusLoadingIdId: PropTypes.number,
  handleDialogOpen: PropTypes.func.isRequired,
};

UpcomingEventsSection.defaultProps = {
  statusLoadingIdId: null,
};
